'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'bookmark';
var width = 384;
var height = 512;
var aliases = [128278,61591];
var unicode = 'f02e';
var svgPathData = ['M16 16l0 484.1 167.9-98 8.1-4.7 8.1 4.7 167.9 98 0-484.1-352 0z', 'M192 397.5l8.1 4.7 167.9 98 0-484.1-352 0 0 484.1 167.9-98 8.1-4.7zM16 518.7L0 528 0 0 384 0 384 528 368 518.7 192 416 16 518.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBookmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;